import { z } from 'zod';

import type { Surface } from './conversation';

// The inbox holds only two surfaces. A mirrored Intercom conversation is a `dm`: one
// private thread with one member, which is all the inbox needs to know about it. Narrowing
// the subset in the model (rather than reusing SURFACES) keeps the column, the filter and
// the UI from ever offering an option the table cannot hold.
export const INBOX_SURFACES = ['comment_thread', 'dm'] as const satisfies readonly Surface[];
export const InboxSurfaceSchema = z.enum(INBOX_SURFACES);
export type InboxSurface = z.infer<typeof InboxSurfaceSchema>;
